/* LD · Header estilo ADOR */
(function () {
  /* Menú de escritorio: desplegables que se abren al hacer clic (details/summary) */
  class LdAdorMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details.ldA-nav__details'));
      this.items.forEach((details) => {
        const summary = details.querySelector('summary');
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', 'false');
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          if (details.open) this.items.forEach((other) => { if (other !== details) other.open = false; });
        });
      });
      this.onOutside = (event) => { if (!this.contains(event.target)) this.closeAll(); };
      this.onKey = (event) => {
        if (event.key !== 'Escape') return;
        const open = this.items.find((details) => details.open);
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      };
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
      });
      document.addEventListener('click', this.onOutside);
      document.addEventListener('keyup', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keyup', this.onKey);
    }

    closeAll() {
      this.items.forEach((details) => { details.open = false; });
    }
  }

  /* Panel lateral del móvil con submenús deslizantes */
  class LdAdorDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('.ldA-drawer__toggle');
      this.panel = this.querySelector('.ldA-drawer__panel');
      this.overlay = this.querySelector('.ldA-drawer__overlay');
      this.toggleButton.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
      this.overlay.addEventListener('click', () => this.close());
      this.querySelectorAll('[data-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = this.querySelector('#' + button.dataset.open);
          if (!panel) return;
          panel.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          const back = panel.querySelector('[data-back]');
          if (back) back.focus({ preventScroll: true });
        });
      });
      this.querySelectorAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = button.closest('.ldA-drawer__sub');
          panel.classList.remove('is-open');
          const opener = this.querySelector('[data-open="' + panel.id + '"]');
          if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
        });
      });
      this.onKey = (event) => { if (event.key === 'Escape' && this.isOpen()) this.close(); };
      this.onResize = () => { if (this.isOpen()) this.setTop(); };
      document.addEventListener('keyup', this.onKey);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKey);
      window.removeEventListener('resize', this.onResize);
      document.documentElement.classList.remove('ldA-lock');
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    /* Coloca el panel justo debajo del header (como Dawn), aunque el header cree su propio contexto de posicionamiento */
    setTop() {
      const header = document.getElementById('header-component') || this;
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      this.style.setProperty('--ldA-top', '0px');
      const origin = Math.round(this.panel.getBoundingClientRect().top);
      const top = bottom - origin;
      const height = Math.max(0, window.innerHeight - bottom) + 'px';
      this.style.setProperty('--ldA-top', top + 'px');
      this.panel.style.height = height;
      this.overlay.style.bottom = 'auto';
      this.overlay.style.height = height;
    }

    open() {
      this.setTop();
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ldA-lock');
    }

    close() {
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ldA-lock');
      this.querySelectorAll('.ldA-drawer__sub.is-open').forEach((panel) => panel.classList.remove('is-open'));
      this.querySelectorAll('[data-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
  }

  /* Selectores de país/moneda e idioma (formulario de localización nativo de Shopify) */
  class LdAdorLocalization extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.discs = Array.from(this.querySelectorAll('.ldA-disc'));
      this.discs.forEach((disc) => {
        const button = disc.querySelector('.ldA-disc__btn');
        const panel = disc.querySelector('.ldA-disc__panel');
        const input = disc.querySelector('input[type="hidden"]');
        const search = disc.querySelector('.ldA-disc__search input');
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const wasOpen = button.getAttribute('aria-expanded') === 'true';
          this.closeAll();
          if (wasOpen) return;
          panel.hidden = false;
          button.setAttribute('aria-expanded', 'true');
          if (search) search.focus({ preventScroll: true });
        });
        panel.addEventListener('click', (event) => event.stopPropagation());
        disc.querySelectorAll('.ldA-disc__link').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            input.value = link.dataset.value;
            this.form.submit();
          });
        });
        if (search) {
          search.addEventListener('input', () => {
            const query = search.value.trim().toLowerCase();
            disc.querySelectorAll('.ldA-disc__list li').forEach((item) => {
              item.hidden = query !== '' && !item.textContent.toLowerCase().includes(query);
            });
          });
        }
      });
      this.onOutside = () => this.closeAll();
      this.onKey = (event) => { if (event.key === 'Escape') this.closeAll(); };
      document.addEventListener('click', this.onOutside);
      document.addEventListener('keyup', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keyup', this.onKey);
    }

    closeAll() {
      this.discs.forEach((disc) => {
        disc.querySelector('.ldA-disc__panel').hidden = true;
        disc.querySelector('.ldA-disc__btn').setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (!customElements.get('ld-ador-menu')) customElements.define('ld-ador-menu', LdAdorMenu);
  if (!customElements.get('ld-ador-drawer')) customElements.define('ld-ador-drawer', LdAdorDrawer);
  if (!customElements.get('ld-ador-localization')) customElements.define('ld-ador-localization', LdAdorLocalization);

  /* Igual que ADOR: por debajo de 990 px se usa el panel lateral en lugar del menú */
  function syncMenuStyle() {
    const header = document.getElementById('header-component');
    if (!header || header.dataset.ldaSync) return;
    header.dataset.ldaSync = 'true';
    const query = window.matchMedia('(max-width: 989px)');
    let themeValue = header.dataset.menuStyle || 'menu';
    let ownChange = false;
    const apply = () => {
      const wanted = query.matches ? 'drawer' : themeValue;
      if (header.dataset.menuStyle !== wanted) {
        ownChange = true;
        header.dataset.menuStyle = wanted;
      }
    };
    new MutationObserver(() => {
      if (ownChange) { ownChange = false; return; }
      themeValue = header.dataset.menuStyle || 'menu';
      apply();
    }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
    query.addEventListener('change', () => {
      apply();
      const drawer = header.querySelector('ld-ador-drawer');
      if (!query.matches && drawer && drawer.isOpen && drawer.isOpen()) drawer.close();
    });
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncMenuStyle);
  else syncMenuStyle();
})();
